import script from "./DetalhesDoAluno.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesDoAluno.vue?vue&type=script&setup=true&lang=js"

import "./DetalhesDoAluno.vue?vue&type=style&index=0&id=5c2f0a54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2f0a54"]])

export default __exports__